<script lang="ts" setup>
  import { ref, onMounted, watch } from 'vue'

  import Sidebar from '@shared/components/sidebar/sidebar.vue'
  import SvgIcon from '@shared/components/svg-icon.vue'
  import CBtn from '@shared/components/ui/c-btn.vue'

  import type { IVisitDocumentSnapshot } from '@internal/types/visits/visit-files/visit-document-snapshot'

  const props = defineProps<{
    snapshotList: IVisitDocumentSnapshot[]
  }>()

  const emit = defineEmits<{
    (e: 'on-close'): void
    (e: 'on-delete', snapshot: IVisitDocumentSnapshot): void
  }>()
  const activeSnapshot = ref<IVisitDocumentSnapshot>()
  const close = () => {
    emit('on-close')
  }

  const changeActiveSnapshot = (snapshot: IVisitDocumentSnapshot) => {
    activeSnapshot.value = snapshot
  }

  const onDeleteHandler = () => {
    if (activeSnapshot.value) {
      emit('on-delete', activeSnapshot.value)
    }
  }

  onMounted(() => {
    if (!props.snapshotList.length) {
      return close()
    }
    activeSnapshot.value = props.snapshotList[0]
  })

  watch(
    () => props.snapshotList,
    () => {
      const isExisted = props.snapshotList.find(el => el.id === activeSnapshot?.value?.id)
      if (isExisted) {
        return
      }
      if (props.snapshotList.length) {
        activeSnapshot.value = props.snapshotList[0]
      } else {
        close()
      }
    }
  )
</script>

<template>
  <sidebar :title="`Snapshots (${snapshotList.length})`" is-close-button @on-close="close">
    <template #body>
      <div class="tw-h-full tw-flex tw-flex-col">
        <img
          v-if="activeSnapshot"
          :src="activeSnapshot.imageSrc"
          class="tw-my-auto tw-max-h-[600px] tw-object-contain"
        />
        <ul class="tw-flex tw-mt-auto tw-overflow-x-auto tw-mb-8">
          <li v-for="snapshot in snapshotList" :key="snapshot.documentId" class="tw-flex-shrink-0">
            <img
              :src="snapshot.imageSrc"
              class="tw-h-[75px] hover:tw-cursor-pointer"
              @click="changeActiveSnapshot(snapshot)"
            />
          </li>
        </ul>
      </div>
    </template>
    <template #controls>
      <c-btn size="small" class="tw-w-min tw-mx-auto" @click="onDeleteHandler">
        <svg-icon name="delete" class="tw-fill-primary-100 tw-mr-10" size="24" />
        Delete
      </c-btn>
    </template>
  </sidebar>
</template>
